"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Name", {
  enumerable: true,
  get: function get() {
    return _SpotIllustration2.Name;
  }
});
Object.defineProperty(exports, "Size", {
  enumerable: true,
  get: function get() {
    return _SpotIllustration2.Size;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "getSpotUrl", {
  enumerable: true,
  get: function get() {
    return _SpotIllustration3.getSpotUrl;
  }
});
var _SpotIllustration = _interopRequireDefault(require("./SpotIllustration"));
var _SpotIllustration2 = require("./SpotIllustration.types");
var _SpotIllustration3 = require("./SpotIllustration.utils");
var _withExperimentalExport = require("../../tools/component/ExperimentalInformation/withExperimentalExport");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = (0, _withExperimentalExport.withExperimentalExport)(_SpotIllustration["default"], {
  name: 'SpotIllustration',
  initDate: '28/09/2022',
  endDate: '',
  owner: {
    developer: 'tiago.aguiar',
    team: 'Cozy'
  },
  docLink: 'https://cozy-web-storybook.quintoandar.com.br/?path=/docs/experimental-spotillustration-1-code--page'
});